export default {
  color: 'text-orange-900',
  link: 'text-white  hover:text-orange-800',

  topBar: 'bg-white',
  sideBar: 'bg-primary-600  text-white',
  textPrimary: 'text-primary-700    hover:text-orange-800',
  logoBar: 'text-orange-900',

  pButton: 'bg-orange-800 text-white hover:bg-gray-500 ',
  sButton: 'bg-gray-500 text-white hover:bg-orange-800  ',
  primary: 'text-white bg-gray-500 hover:bg-primary-700 ',

  filter: 'bg-white text-orange-800 border-orange-800 hover:bg-orange-800',
  required: 'text-primary-500 ',
  actionTable: 'text-black opacity-75   hover:text-primary-500 ',
  newColor: 'text-primary-500  hover:text-primary-500  ',
  pButton1: 'bg-primary-600  text-white hover:bg-gray-500 ',
  primary1: 'text-white bg-gray-500 hover:bg-primary-600 ',
  white: 'text-white',
};

/*

export default {
        color:"text-pink-900",

        topBar:"bg-white",
        sideBar:"bg-pink-800 text-white",
        textPrimary:"text-pink-900 hover:text-pink-00  ",
        logoBar:" text-pink-600",

        pButton:"bg-pink-500 text-white hover:bg-pink-600 ",
        sButton:"text-pink-500 bg-gray-300 hover:bg-pink-500 hover:text-white  ",

        primary:"text-white bg-pink-500 hover:bg-pink-600" ,

        filter:"bg-white text-pink-600 border-pink-600 hover:bg-pink-600"
}
*/
